<template>
  <div>

    <div class="container">
      <div class="containerBox">
        <div class="swiper-container banner-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide item" v-for="(item, index) in pointImgList" :key="index">
              <a :href="item.link" target="_blank">
                <img class="img" :src="item.cover" alt="">
              </a>
            </div>
          </div>

          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev" v-if="pointImgList.length > 1"></div>
          <div class="swiper-button-next" v-if="pointImgList.length > 1"></div>
        </div>
      </div>

      <div class="" v-if="articleList.length > 0">
        <div class="Index-article">
          <div class="Index-fl">
            <div class="Index-fistlink" @click="articlink(articleList[0])">
              <div class="article-title">{{ articleList[0].title }}</div>
            </div>
            <div class="article-list">
              <div v-for="(item, index) in articleList" :key="index" v-if="9 > index && index > 0"
                @click="articlink(item)">
                {{ item.title }}</div>
            </div>
          </div>
          <div class="article-pic">
            <img :src="$uploadUrl + articleList[0].cover">
          </div>
        </div>
      </div>

      <!-- 纪念堂 -->
      <div class="Memhall">
        <div class="Memhall-top">
          <div class="Memhall-title"><span>至德-</span>纪念堂</div>
          <router-link class="Memhall-all" :to="{ path: '/memorial' }">查看全部</router-link>
        </div>

        <div class="Memorial">
          <div class="MemorialBox">
            <router-link :to="{ path: '/memorialext', query: { id: item.id } }" class="Memorialst"
              v-for="(item, index) in Memorialist" :key="index" v-if="5 > index">
              <img :src="$uploadUrl + item.outside_style.thumbnail" class="Memorialst-pic">
              <div class="Memorialst-name">{{ item.name }}</div>
              <div class="Memorialst-worship">祭拜</div>
              <div class="Memorialst-count">{{ item.pay_count }}</div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 联络联谊 -->
      <div class="Fellowship">
        <div class="Fellowship-top">
          <div class="Fellowship-title"><span>至德-</span>联络联谊</div>
          <router-link class="Fellowship-all" :to="{ path: '/liaison' }">查看全部</router-link>
        </div>

        <div class="Memorial">
          <div class="FellowshipBox">
            <router-link :to="{ path: '/liaisoninfo', query: { id: item.id } }" class="Fellowshipever"
              v-for="(item, index) in Fellowshiplist" :key="index" v-if="8 > index">
              <img v-if="item.images.length > 0" :src="item.images[0].url" class="Fellowshiplist-pic">
              <img v-else src="" class="Fellowshiplist-pic" />
              <div class="Fellowshiplist-name">{{ item.title }}</div>
              <div class="Fellowshiplist-worship">{{ item.intro.slice(0, 50) + '...' }}<router-link
                  :to="{ path: '/liaisoninfo', query: { id: item.id } }">【详细】</router-link></div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 人物春秋 -->
      <div class="Character">
        <div class="Character-top">
          <div class="Character-title"><span>至德-</span>人物春秋</div>
          <router-link class="Character-all" :to="{ path: '/spandaut' }">查看全部</router-link>
        </div>

        <div class="Memorial">
          <div class="CharacterBox">
            <router-link :to="{ path: '/spandautinfo', query: { id: item.id } }" class="Characterever"
              v-for="(item, index) in Characterlist" :key="index" v-if="5 > index">
              <img :src="item.cover" class="Character-pic">
              <div class="Character-name">{{ item.title }}</div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 至德-企业长廊 -->
      <div class="Fellowship">
        <div class="Fellowship-top">
          <div class="Fellowship-title"><span>至德-</span>企业长廊</div>
          <router-link class="Fellowship-all" :to="{ path: '/economic' }">查看全部</router-link>
        </div>

        <div class="Memorial">
          <div class="FellowshipBox">
            <div class="Firmever" v-for="(item, index) in Firmlist" :key="index" v-if="10 > index && item.company_info != null"
              @click="islink(item.id)">
              <img :src="item.company_info.logo">
            </div>
          </div>
        </div>
      </div>

      <!-- 至德-友情链接 -->
      <div class="Fellowship">
        <div class="Fellowship-top">
          <div class="Fellowship-title"><span>至德-</span>友情链接</div>
        </div>

        <div class="Memorial">
          <div class="FellowshipBox">
            <a :href="item.link" class="Linkever" target="_blank" v-for="(item, index) in Linklist" :key="index">
              <img class="img" :src="item.cover" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Swiper from "swiper"
export default {
  data() {
    return {
      token: localStorage.pctoken,
      pointImgList: [],
      articleList: [],
      Memorialist: [],
      Fellowshiplist: [],
      Characterlist: [],
      Firmlist: [],
      Linklist: []
    };
  },
  created() {
    this.loadbanner();
    this.Article();
    this.GetMemorial();
    this.Getfellowship();
    this.Getcharacter();
    this.Getfirm();
  },
  mounted() {

  },
  methods: {

    //获取banner数据和友情链接
    loadbanner() {
      this.$layer.loading();
      this.$http.get('index?is_pc=0').then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll('loading');
          this.pointImgList = res.data.data.ad;
          this.Linklist = res.data.data.link;
          this.$nextTick(() => {
            this.bannerPoint()
          })

        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //banner
    bannerPoint() {
      new Swiper(".banner-container", {
        loop: true,
        autoplay: {
          delay: 2000, //1秒切换一次
          // disableOnInteraction: false
        },
        updateOnImagesReady: true,
        slidesPerView: 1,  //设置slider容器能够同时显示的slides数量
        //spaceBetween : '10%',按container的百分比

        observer: true,//在 Swiper 的上启用动态检查器(Mutation Observer)，如果你更改swiper 的样式（隐藏/显示）或修改其子元素（添加/删除幻灯片），Swiper 会更新（重新初始化）并触发 observerUpdate 事件。
        observeParents: true,
        observeSlideChildren: true,

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          paginationClickable: true,
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next', // 右按钮
          prevEl: '.swiper-button-prev', // 左按钮
        },
      })
    },

    //获取文章
    Article() {
      this.$http.get('all/articles').then((res) => {
        if (res.data.code == 200) {
          this.articleList = res.data.data.data;
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //文章跳转
    articlink(info) {
      if (info.category == '第一时间') {
        this.$router.push({ path: '/ftimeinfo', query: { id: info.id } });
      } else if (info.category == '天下文章') {
        this.$router.push({ path: '/wholeinfo', query: { id: info.id } });
      } else if (info.category == '人物春秋') {
        this.$router.push({ path: '/spandautinfo', query: { id: info.id } });
      } else if (info.category == '台海两岸') {
        this.$router.push({ path: '/straitinfo', query: { id: info.id } });
      }
    },

    //获取纪念堂
    GetMemorial() {
      this.$http.get('zhide/memorial').then((res) => {
        if (res.data.code == 200) {
          this.Memorialist = res.data.data.data;
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //获取至德-联络联谊
    Getfellowship() {
      this.$http.get('contact').then((res) => {
        if (res.data.code == 200) {
          this.Fellowshiplist = res.data.data.data;
          console.log(this.Fellowshiplist);
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //获取至德-人物春秋
    Getcharacter() {
      this.$http.get('article/3').then((res) => {
        if (res.data.code == 200) {
          this.Characterlist = res.data.data.data;
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    //获取企业长廊
    Getfirm() {
      this.$http.get('company').then((res) => {
        if (res.data.code == 200) {
          this.Firmlist = res.data.data.data;
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },

    islink(id) {
      if (!localStorage.user) {
        this.$confirm('请登录后查看，是否登录', '提示', {
          confirmButtonText: '登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: "login" })
        });
      } else if (JSON.parse(localStorage.user).company_id == null || JSON.parse(localStorage.user).company_id == 0) {
        this.$confirm('请认证后查看，是否去认证', '提示', {
          confirmButtonText: '认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: "Agreement" })
        });
      }else if (JSON.parse(localStorage.user).company_id != null || JSON.parse(localStorage.user).company_id != 0) {

        this.$http.post('/check/company_status',{
          company_id: JSON.parse(localStorage.user).company_id
        },{
          headers: {
              'Authorization': 'Bearer ' + this.token
          }
        }).then((response)=>{
          this.$layer.closeAll('loading');
          if(response.data.code == 200){
            if (response.data.data == 1) {
              this.$layer.msg("正在审核中，请稍后查看");
              setTimeout(() => {
                this.$router.push({ name: "Index" });
              }, 1800);
            } else if (response.data.data == 2) {
              this.$confirm("认证未通过，是否重新认证", "提示", {
                confirmButtonText: "认证",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$router.push({ name: "Agreement" });
                })
                .catch(() => {
                  this.$router.push({ name: "Index" });
                });
            } else {
              this.$router.push({
                path: "/enterinfo",
                query: {
                  id: id
                }
              })
            }
          }
        });
      }
    },

  },
};
</script>
<style scoped>
.container {
  margin-bottom: 60px;
}

.containerBox {
  margin: 0 auto;
  height: 480px;
}

.containerBox .item {
  width: 100%;
  height: 480px;
}

.containerBox .item .img {
  width: 100%;
  height: 480px;
}

::v-deep .container .swiper-button-prev {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  left: 10%;
  background: url(../../../public/images/anheileft.png) center rgba(255, 255, 255, 0.70) no-repeat;
}

::v-deep .container .swiper-button-prev:hover {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: url(../../../public/images/anleft.png) center rgba(215, 30, 28, 1) no-repeat;
}

::v-deep .container .swiper-button-next {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  right: 10%;
  background: url(../../../public/images/anheiright.png) center rgba(255, 255, 255, 0.70) no-repeat;
}

::v-deep .container .swiper-button-next:hover {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: url(../../../public/images/anright.png) center rgba(215, 30, 28, 1) no-repeat;
}

.Index-fl {
  width: 50%;
  flex: 1;
}

.Index-fistlink {
  cursor: pointer;
}

.Index-article {
  width: 1200px;
  margin: 54px auto 0;
  display: flex;
}

.article-title {
  font-weight: bold;
  font-size: 24px;
  color: #282828;
  height: 66px;
  overflow: hidden;
}

.article-cent {
  font-size: 14px;
  color: #999999;
  line-height: 24px;
  margin-top: 10px;
  height: 76px;
}

.article-cent span {
  color: #D71E1C;
}

.article-pic {
  width: 511px;
  height: 372px;
  border-radius: 12px;
  margin-left: 30px;
}

.article-pic img {
  width: 511px;
  height: 372px;
  border-radius: 12px;
}

.article-list {
  margin-top: 10px;
}

.article-list div {
  display: block;
  font-size: 16px;
  color: #282828;
  line-height: 34px;
  background: url(../../../public/images/dian.png) left center no-repeat;
  background-size: 8px 8px;
  padding-left: 16px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article-list div:hover {
  color: #D71E1C;
  text-decoration: underline;
  background: url(../../../public/images/dianhong.png) left center no-repeat;
  background-size: 8px 8px;
}

.article-all {
  display: block;
  width: 100px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 32px;
  border-radius: 16px;
  border: 1px solid #D8D8D8;
  margin: 40px auto 0;
  background: url(../../../public/images/goin.png) 90px center no-repeat;
  padding-left: 20px;
  background-size: 15px 12px;
}

.Memhall {
  background: url(../../../public/images/jntbj.png) top no-repeat;
  margin-top: 60px;
}

.Memhall-top {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 60px;
}

.Memhall-title {
  font-weight: bold;
  font-size: 32px;
  color: #282828;
}

.Memhall-title span {
  color: #D71E1C;
}

.Memhall-all {
  width: 100px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 32px;
  border-radius: 16px;
  border: 1px solid #D8D8D8;
  background: url(../../../public/images/goin.png) 90px center no-repeat;
  padding-left: 20px;
  background-size: 15px 12px;
}

.MemorialBox {
  width: 1200px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
}

.Memorialst {
  width: 224px;
  background: #D8D8D8;
  border-radius: 12px;
  position: relative;
}

.Memorialst-pic {
  width: 224px;
  height: 224px;
  background: #D8D8D8;
  border-radius: 12px;
}

.Memorialst-name {
  font-size: 18px;
  color: #333333;
  text-align: center;
  margin-top: 6px;
}

.Memorialst-worship {
  width: 64px;
  height: 28px;
  background: linear-gradient(139deg, #ED403C 0%, #D71E1C 100%);
  border-radius: 14px;
  margin: 8px auto;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  line-height: 28px;
}

.Memorialst-count {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 24px;
  background: linear-gradient(137deg, #FFB73A 0%, #FE6809 100%);
  border-radius: 12px 12px 12px 0px;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
}

.Fellowship {
  width: 1200px;
  margin: 50px auto 0;
}

.Fellowship-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #D8D8D8;
  padding-bottom: 15px;
}

.Fellowship-all {
  width: 100px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 32px;
  border-radius: 16px;
  border: 1px solid #D8D8D8;
  background: url(../../../public/images/goin.png) 90px center no-repeat;
  padding-left: 20px;
  background-size: 15px 12px;
}

.Fellowship-title {
  font-weight: bold;
  font-size: 32px;
  color: #282828;
}

.Fellowship-title span {
  color: #D71E1C;
}

.Fellowshipever {
  width: 285px;
  margin-left: 20px;
  margin-top: 40px;
}

.Fellowshipever:nth-child(1),
.Fellowshipever:nth-child(5) {
  margin-left: 0;
}

.Fellowshiplist-pic {
  width: 285px;
  height: 207px;
  border-radius: 12px;
}

.Fellowshiplist-pic img {
  width: 285px;
  height: 207px;
  border-radius: 12px;
}

.Fellowshiplist-name {
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.FellowshipBox {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}

.Fellowshiplist-worship {
  font-size: 14px;
  color: #999999;
  line-height: 22px;
  margin-top: 10px;
}

.Fellowshiplist-worship a {
  color: #D71E1C;
}

.Character {
  background: url(../../../public/images/juxbj.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 60px;
  padding: 60px 0;
}

.Character-top {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F04442;
  padding-bottom: 15px;
}

.Character-title {
  font-weight: bold;
  font-size: 32px;
  color: #282828;
}

.Character-title span {
  color: #FFFFFF;
}

.Character-all {
  width: 100px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #fff;
  line-height: 32px;
  border-radius: 16px;
  border: 1px solid #F04442;
  background: url(../../../public/images/goinbai.png) 90px center no-repeat;
  padding-left: 20px;
  background-size: 15px 12px;
}

.CharacterBox {
  width: 1200px;
  margin: 20px auto 0;
  display: flex;
  flex-wrap: wrap;
}

.Characterever {
  width: 224px;
  margin-left: 20px;
}

.Characterever:nth-child(1) {
  margin-left: 0;
}

.Character-pic {
  width: 224px;
  height: 277px;
  border-radius: 12px;
}

.Character-pic img {
  width: 224px;
  height: 277px;
  border-radius: 12px;
}

.Character-name {
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  margin-top: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Firmever {
  width: 224px;
  height: 224px;
  border-radius: 12px;
  border: 1px solid #D8D8D8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
  cursor: pointer;
}

.Firmever:nth-child(1),
.Firmever:nth-child(6) {
  margin-left: 0;
}

.Firmever img {
  max-width: 208px;
  max-height: 142px;
  object-fit: contain;
}

.Linkever {
  width: 188px;
  height: 84px;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 12px;
}

.Linkever:nth-child(1) {
  margin-left: 0;
}

.Linkever img {
  max-width: 156px;
  max-height: 72px;
  object-fit: contain;
}
</style>